/**
 * 5.0j Locked-language client-facing surface.
 * Pins i18n.changeLanguage(position.language) at mount from the consent query.
 * The admin global language toggle does NOT propagate to /c/* routes (separate tree).
 */
import { useEffect } from "react";
import { Outlet, useParams } from "react-router";
import { useTranslation } from "react-i18next";

import { useConsentQuery } from "@/features/candidate/hooks";

export default function CandidateLayout() {
  const { positionToken } = useParams<{ positionToken: string }>();
  const { i18n } = useTranslation();
  const { data } = useConsentQuery(positionToken ?? "");

  useEffect(() => {
    if (data?.position_language) {
      void i18n.changeLanguage(data.position_language);
    }
  }, [data?.position_language, i18n]);

  return (
    <div className="candidate-shell min-h-screen w-full bg-background">
      <Outlet />
    </div>
  );
}
